import React from 'react'
import { useEffect } from 'react'
import AllInvoice from '../../component/AllInvoice'
import axios from 'axios'
import { useState } from 'react'
import { Box } from '@chakra-ui/react'
import { Auth } from '../../component/Auth'
const InvoiceFailed = () => {
    const [tData, setTData] = useState([])
    const [isLoading, setIsLoading] = useState({loading: true, error: false})
    useEffect(() => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_RALCO_API_URL}/api/invoice/filter/invoice?statusId=FAILED`,
            headers: { 
              'Authorization': Auth()
             }
          };
          
          axios.request(config)
          .then((response) => {
            setTData(response.data);
            setIsLoading({loading: false, error: false})
          })
          .catch((error) => {
            console.log(error);
            setIsLoading({loading: false, error: true})
          });
    },[])

  return (
    <Box p={5} flex="1" w={'100%'}>
    {/* <Box>
         <Heading ml={3} fontSize={{base: '15px', md: '24px', lg: '24px', xl: '24px', '2xl': '24px'}}>Invoice Failed</Heading>
    </Box> */}
    <AllInvoice
        title={'Invoice Failed'}
        head={["Invoice ID","Tenure ID","Order ID", "Invoice Date", "Due Date", "Cut Off Date", "Invoice Total", "Status" ]}
        data={tData}
        isLoading={isLoading}
    />
    </Box>
  )
}

export default InvoiceFailed